import React from 'react';

import { SimpleImage } from '$partials/media';
import ModuleContainer from '$partials/modules/container.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').ThreeColumnContentBlock}
 */
const ThreeColumnContentBlock = ({
    columns,
    ctaLabel,
    ctaLink,
    heading,
    text,
}) => {
    return (
        <ModuleContainer
            ctaLabel={ctaLabel}
            ctaLink={ctaLink}
            heading={heading}
            renderChildrenBelow={true}
            text={text}>
            <div className='grid grid-cols-1 sm:grid-cols-3 gap-8 pb-30'>
                {columns?.map((column, i) => {
                    return (
                        <div
                            className='pb-30'
                            key={i}>
                            {column?.media &&
                                <div className='relative aspect-3/2 overflow-hidden rounded mb-20'>
                                    {column?.media?.image &&
                                        <SimpleImage
                                            {...column?.media.image}
                                            className='w-full h-full object-cover' />
                                    }
                                    {column?.media?.video &&
                                        <video
                                            autoPlay={true}
                                            className='w-full h-full object-cover pointer-events-none'
                                            loop={true}
                                            muted={true}
                                            playsInline={true}
                                            poster={column?.media.video.poster?.url}
                                            src={column?.media.video.src} />
                                    }
                                </div>
                            }

                            <h3 className='pr-20 mb-20 ml-side-col sm:ml-0 max-w-text-length'>
                                {column.heading}
                            </h3>

                            <div
                                className='rich-text pr-20 ml-side-col sm:ml-0 max-w-text-length'
                                dangerouslySetInnerHTML={{__html: column.text }} />
                        </div>
                    );
                })}
            </div>
        </ModuleContainer>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ThreeColumnContentBlock;
